module.exports = __webpack_public_path__ + "static/media/PrimeDayReports2.7a6ef4b0.svg";